import { render } from "./ClassmateList.vue?vue&type=template&id=1f46a32b&scoped=true"
import script from "./ClassmateList.vue?vue&type=script&lang=js"
export * from "./ClassmateList.vue?vue&type=script&lang=js"

import "./ClassmateList.vue?vue&type=style&index=0&id=1f46a32b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f46a32b"],['__file',"src/views/h5/luqiao/project/classmate/ClassmateList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f46a32b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f46a32b', __exports__)) {
    api.reload('1f46a32b', __exports__)
  }
  
  module.hot.accept("./ClassmateList.vue?vue&type=template&id=1f46a32b&scoped=true", () => {
    api.rerender('1f46a32b', render)
  })

}


export default __exports__